<template>
  <div>
    <slot>
      <div v-html="truncatedText"></div>
    </slot>
  </div>
</template>

<script>
import truncate from 'truncate-html';

export default {
  props: {
    text: {
      type: String,
      default() {
        return '';
      }
    },

    length: {
      type: Number,
      required: false,
      default() {
        return 170;
      }
    },
  },

  data() {
    return {
      truncatedText: ''
    };
  },

  mounted() {
    if(this.text) {
      this.truncatedText = truncate(this.text, this.length);
    } else {
      if (this.$slots.default) {
        this.$slots.default[0].elm.textContent = truncate(this.$slots.default[0].elm.textContent, this.length);
      }
    }
  }
};
</script>

<style scoped>

</style>